// Config file 

export const googleMapId = "80ed14530a4461a4";
export const googleMapApiKey = "AIzaSyBzEOuxVwMPjC7t02BBvme_cBnHFPPBS5c";
export const apiPrefix = "https://sb.iimswiss.com/api/SwissTrackAPI";
// export const apiPrefix = "http://localhost:65145/api/SwissTrackAPI";